/*eslint-disable*/
import React, { useState } from "react";
import { Container } from "reactstrap";

import queuePoster from "assets/img/edge/debrief/queue.jpg";
import pilotsPoster from "assets/img/edge/debrief/pilots.jpg";
import timebackPoster from "assets/img/edge/debrief/timeback.jpg";

const PUB = process.env.PUBLIC_URL || "";

const CLIPS = [
  {
    id: "queue",
    title: "The Queue",
    hook: "Your bottleneck isn't your team.",
    poster: queuePoster,
    src: `${PUB}/video/queue.mp4`,
  },
  {
    id: "pilots",
    title: "The Pilot Graveyard",
    hook: "Four AI pilots. Zero in production.",
    poster: pilotsPoster,
    src: `${PUB}/video/pilots.mp4`,
  },
  {
    id: "timeback",
    title: "Time Back",
    hook: "Nine hours a week. Gone.",
    poster: timebackPoster,
    src: `${PUB}/video/timeback.mp4`,
  },
];

function Debrief() {
  const [playing, setPlaying] = useState(null);

  return (
    <section className="edge-debrief-section" id="debrief">
      <Container>
        <span className="edge-section-eyebrow">{"// FROM THE FIELD"}</span>
        <h2 className="edge-section-heading">
          Three bottlenecks<br />
          <span className="muted">we keep finding.</span>
        </h2>
        <p className="edge-section-sub">
          Thirty seconds each. The captions carry it — sound is optional.
        </p>

        <div className="edge-debrief-grid">
          {CLIPS.map(c => (
            <div key={c.id} className="edge-debrief-card">
              <div className="edge-debrief-frame">
                {playing === c.id ? (
                  <video
                    className="edge-debrief-video"
                    src={c.src}
                    poster={c.poster}
                    controls
                    autoPlay
                    playsInline
                    onEnded={() => setPlaying(null)}
                  />
                ) : (
                  <button
                    type="button"
                    className="edge-debrief-trigger"
                    onClick={() => setPlaying(c.id)}
                    aria-label={`Play ${c.title} — ${c.hook}`}
                  >
                    <img src={c.poster} alt="" className="edge-debrief-poster" />
                    <span className="edge-debrief-scrim" />
                    <span className="edge-debrief-rule" />
                    <span className="edge-debrief-hook">{c.hook}</span>
                    <span className="edge-debrief-time">0:29</span>
                    <span className="edge-debrief-play">
                      <svg width="12" height="14" viewBox="0 0 11 12" fill="#070f1a">
                        <path d="M0 0l11 6-11 6z" />
                      </svg>
                    </span>
                  </button>
                )}
              </div>
              <div className="edge-debrief-cap">{c.title}</div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default Debrief;
